import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-[1280px] flex-col items-center justify-center px-4 py-20 text-center md:px-6">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-foreground-500">
        <i className="ri-search-eye-line text-3xl"></i>
      </span>
      <h1 className="mt-6 font-heading text-5xl font-black text-foreground-950">404</h1>
      <p className="mt-3 font-heading text-xl font-bold text-foreground-800">页面走丢了，或还没有生成</p>
      <p className="mt-2 font-mono text-sm text-foreground-500">{location.pathname}</p>
      <p className="mt-2 text-sm text-foreground-500">这个页面可能不存在或已被移除，去看看其他热点事件吧。</p>
      <Link
        to="/"
        className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
      >
        返回首页 <i className="ri-arrow-right-line"></i>
      </Link>
    </div>
  );
}